import React from 'react';
import Icon from '../../../components/AppIcon';
import { useNavigate } from 'react-router-dom';

const RecentActivity = ({ activities }) => {
  const navigate = useNavigate();
  const getActivityIcon = (type) => {
    switch (type) {
      case 'income':
        return { name: 'ArrowDownLeft', color: 'var(--color-success)' };
      case 'expense':
        return { name: 'ArrowUpRight', color: 'var(--color-error)' };
      case 'transfer':
        return { name: 'ArrowLeftRight', color: 'var(--color-accent)' };
      default:
        return { name: 'Activity', color: 'var(--color-foreground)' };
    }
  };

  const formatDate = (date) => {
    const activityDate = new Date(date);
    const today = new Date();
    const diffTime = Math.abs(today - activityDate);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    return activityDate?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="bg-card rounded-lg p-20 md:p-24 lg:p-28 shadow-elevation-2">
      <div className="flex items-center justify-between mb-20 md:mb-24">
        <h3 className="text-lg md:text-xl font-heading font-semibold text-card-foreground">
          Recent Activity
        </h3>
        <button 
          onClick={() => navigate('/transactions-management')}
          className="text-sm text-primary hover:text-accent transition-smooth font-caption min-h-[44px] px-8"
        >
          View All
        </button>
      </div>
      <div className="space-y-12 md:space-y-16">
        {activities?.length === 0 ? (
          <div className="text-center py-32 md:py-40">
            <Icon name="Inbox" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-16" />
            <p className="text-sm md:text-base text-muted-foreground font-caption">
              No recent activity to display
            </p>
          </div>
        ) : (
          activities?.map((activity) => {
            const icon = getActivityIcon(activity?.type);
            return (
              <div
                key={activity?.id}
                className="flex items-center justify-between p-12 md:p-16 rounded-lg hover:bg-muted transition-smooth"
              >
                <div className="flex items-center space-x-12 md:space-x-16 flex-1 min-w-0">
                  <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-muted rounded-lg flex-shrink-0">
                    <Icon name={icon?.name} size={20} color={icon?.color} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm md:text-base font-caption font-medium text-card-foreground truncate">
                      {activity?.description}
                    </p>
                    <p className="text-xs md:text-sm text-muted-foreground mt-2">
                      {activity?.category} • {formatDate(activity?.date)}
                    </p>
                  </div>
                </div>
                <div className="text-right ml-12 flex-shrink-0">
                  <p className={`text-sm md:text-base font-caption font-semibold whitespace-nowrap ${
                    activity?.type === 'income' ? 'text-success' : activity?.type === 'expense' ? 'text-error' : 'text-foreground'
                  }`}>
                    {activity?.type === 'expense' ? '-' : activity?.type === 'income' ? '+' : ''}
                    {activity?.currency}{Math.abs(activity?.amount)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </p>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default RecentActivity;